import React, { useEffect } from 'react'
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { NavLink } from "react-router-dom";


const Files = (props) => {
    
    return (
        <Container>
            <Row>
                <Col>
                    <br />
                    <h1 className="center-align">Solutions</h1>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="search-option">
                        <br />
                        <span className="title">Document Search</span>
                        <span className="description"><br />Upload and search throught hundreds of PDF documents to locate very specific information and gain valuable insights.</span>
                    </p>

                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="search-option">
                        <br />
                        <span className="title">Contract Review</span>
                        <span className="description"><br />Identify clauses, terms, provisions, and concepts across your complete document dataset.</span>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="search-option">
                        <br />
                        <span className="title">Regulatory Review</span>
                            <span className="description"><br />Customize your search to locate the most appropriate and applicable regulatory and case law records for your analysis</span>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="search-option">
                        <br />
                        <span className="title">Compliance Review</span>
                        <span className="description"><br />Accelerate review of corporate legal and financial documents and records for compliance and due dilligence purposes.</span>
                    </p>
                </Col>
            </Row>
            <Row>
                <Col className="text-align-end">
                    <NavLink to="/savedsearches">
                        <Button variant="outline-primary">Saved Searches</Button>{' '}
                    </NavLink>
                    <NavLink to="/projects">
                        <Button variant="primary">Start new search</Button>{' '}
                    </NavLink>
                </Col>
            </Row>
        </Container>
    );
};
export default Files;